export default __webpack_public_path__ + "static/media/notice.fba9aa02.svg";